/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Conflict_DescriptionInputs */



/**
* | output |
* | --- |
* | "{count} file(s) already exist at the destination. Choose what to do:" |
*
* @param {Spaces_Conflict_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_conflict_description = /** @type {((inputs: Spaces_Conflict_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Conflict_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Datei(en) existieren bereits am Ziel. Wählen Sie eine Aktion:`)
	return /** @type {LocalizedString} */ (`${i?.count} file(s) already exist at the destination. Choose what to do:`)
});